import { cn } from "@/lib/utils";
import { OverallRatingEnum } from "@/pages/search/types";

export interface StatusBoxProps {
  children: React.ReactNode;
  className?: string;
  rating?: keyof typeof OverallRatingEnum;
  variant?: "large" | "small";
}

export default function StatusBox({
  children,
  className,
  rating,
  variant = "small",
}: StatusBoxProps) {
  let ratingClassName = "";

  if (rating) {
    if (rating === OverallRatingEnum.DISLIKE) {
      ratingClassName = "bg-linear-45 from-sky-blue to-periwinkle";
    }
    if (rating === OverallRatingEnum.LIKE) {
      ratingClassName = "bg-linear-180 from-maize to-apricot-light";
    }
    if (rating === OverallRatingEnum.LOVE) {
      ratingClassName = "bg-linear-180 from-coral to-scarlet";
    }
  }

  return (
    <div
      className={cn(
        "absolute flex aspect-square w-[38%] max-w-10 items-center justify-center rounded-[3px] shadow-0-0-4 shadow-black md:rounded-[4px] md:shadow-none",
        variant === "small" ? "-top-[3px] left-1/10" : "-top-2.5 left-2.5",
        ratingClassName,
        className
      )}
    >
      {children}
    </div>
  );
}
